export const NAME = 'findActivity'



// WEBPACK FOOTER //
// ../source/views/FindActivity/constants.js